export function formatTHB(amount: number): string {
  return `฿${new Intl.NumberFormat("th-TH").format(amount)}`;
}
